import { render, staticRenderFns } from "./secondary-skills.vue?vue&type=template&id=08c97052&scoped=true&"
import script from "./secondary-skills.vue?vue&type=script&lang=js&"
export * from "./secondary-skills.vue?vue&type=script&lang=js&"
import style0 from "./secondary-skills.vue?vue&type=style&index=0&id=08c97052&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c97052",
  null
  
)

export default component.exports